module.exports = __webpack_public_path__ + "static/media/ejaro.6706839d.jpg";